module.exports = __webpack_public_path__ + "img/interior-define-monitor.23572f4a.png";